import { Controller } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { Lens } from "@hookform/lenses"
import { ReasonPointOfCareSelection } from "@/modules/patients/detail/progress-note/point-of-care/components/fields/reason-point-of-care-selection"
import { isReasonForChoosingType } from "@/modules/patients/detail/progress-note/point-of-care/constants"
import { PointOfCareFormType } from "@/modules/patients/detail/progress-note/point-of-care/schema"

type ReasonForChoosingTypeProps = {
  reasonForChoosingTypeLens: Lens<PointOfCareFormType["reasonForChoosingType"]>
  containerClassName?: string
}

export const ReasonForChoosingType = ({
  reasonForChoosingTypeLens,
  containerClassName,
}: ReasonForChoosingTypeProps) => {
  const { t } = useTranslation()
  const { control, name } = reasonForChoosingTypeLens.interop()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <ReasonPointOfCareSelection
          onValueChange={(value: string): void => {
            if (isReasonForChoosingType(value)) {
              field.onChange(value)
            }
          }}
          value={field.value ?? undefined}
          label={`${t("episodeOfCare.progressNote.pointOfCare.reasonForChoosingActual")}*`}
          error={`${fieldState.error?.message ?? ""}`}
          containerClassName={containerClassName}
        />
      )}
    />
  )
}
